import * as React from 'react';
import { Col, Row } from 'antd';
import { MenuOutlined, MinusOutlined } from '@ant-design/icons';
import './WidgetInputRowContentWrapper.scss';

interface WidgetInputRowContentWrapperProps {
  index?: number;
  /**
   * Ogni elemento deve essere in una <Col
   */
  children: React.ReactNode;
  action: React.ReactNode;
}

/**
 * Wrapper del contenuto singola riga del widget a preferenza multipla
 */
export function WidgetInputRowContentWrapper(
  props: WidgetInputRowContentWrapperProps
) {
  const { index, children, action } = props;

  return (
    <Row align="middle" className="widget-input-row-content-wrapper">
      <Col flex="0 0 25px">
        <span className="drag-button">
          <MenuOutlined />
        </span>
      </Col>
      <Col flex="0 0 28px" className="index-number">
        {(index ?? 0) + 1}
      </Col>
      <Col flex="1 1 0">
        <Row align="middle" className="input-wrapper">
          {children}
        </Row>
      </Col>
      <Col flex="0 0 30px" className="action-button">
        {action}
      </Col>
    </Row>
  );
}
